/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  
  const ageVerificationPopup = {
    init() {
      if (sessionStorage.getItem('advertOnce') !== 'true') {
        document.querySelector('.age-verification-popup').classList.remove('hide');
      } else {
        document.querySelector('.age-verification-popup').classList.add('hide');
      }
    
      document.querySelector('.age-verification-popup .yes-button').addEventListener('click', function() {
        document.querySelector('.age-verification-popup').classList.add('hide');
        sessionStorage.setItem('advertOnce', 'true');
      });
    
      document.querySelector('.age-verification-popup .no-button').addEventListener('click', function() {
        document.querySelector('.age-verification-popup').classList.remove('hide');
        sessionStorage.setItem('advertOnce', '');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    ageVerificationPopup.init();
  })

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})(jQuery);
